import "~/app/init/sentry.ts";
import "~/app/init/windowConfig.js";

import { StrictMode, Suspense } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { QueryParamProvider } from "use-query-params";

import { ErrorBoundaryWithoutRouter as ErrorBoundary } from "~/app/components/ErrorBoundary";

import { SearchProvider } from "~/app/contexts/search";

import { BASE_URL } from "~/app/constant/env";

import styleVariables from "~/app/styles/exports.module.scss";
import "~/app/styles/global.scss";

import ConfigProvider from "./ConfigProvider";
import MainRouter from "./MainRouter";

import queryClient from "./app/config/queryClientConfig";

ReactDOM.createRoot(document.getElementById("root")).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <ErrorBoundary>
          <ConfigProvider>
            <SearchProvider>
              <ThemeProvider theme={styleVariables}>
                <BrowserRouter basename={BASE_URL}>
                  <QueryParamProvider ReactRouterRoute={Route}>
                    <MainRouter />
                  </QueryParamProvider>
                </BrowserRouter>
              </ThemeProvider>
            </SearchProvider>
          </ConfigProvider>
        </ErrorBoundary>
      </Suspense>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  </StrictMode>
);

/**
 * Vite Preload Error Handling
 * This can happen if a new deployment is done while the user is already navigating on the application
 * https://vitejs.dev/guide/build.html#load-error-handling
 */
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});
